import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UseCase } from '@digibricks/domains';
export var UPDATE_SUBMISSION_USE_CASE = 'UPDATE_SUBMISSION_USE_CASE';
export var UpdateSubmissionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateSubmissionUseCase, _UseCase);

  var _super = _createSuper(UpdateSubmissionUseCase);

  function UpdateSubmissionUseCase(submissionRepository) {
    var _this;

    _classCallCheck(this, UpdateSubmissionUseCase);

    _this = _super.call(this);
    _this.submissionRepository = submissionRepository;
    return _this;
  }

  _createClass(UpdateSubmissionUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      var submission = useCaseInput.submission,
          input = useCaseInput.input;
      var collection = [{
        argument: submission,
        argumentName: 'Submission'
      }, {
        argument: input.comment,
        argumentName: 'Comment'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var resultOrError, updateOrError, input, submission, comment, isContentUpdated;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                _context.next = 5;
                return this.submissionRepository.update(useCaseInput);

              case 5:
                updateOrError = _context.sent;

                if (!updateOrError.isFailure) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(updateOrError.error));

              case 8:
                input = useCaseInput.input, submission = useCaseInput.submission;
                comment = input.comment;

                if (comment) {
                  isContentUpdated = submission.comment !== comment;

                  if (isContentUpdated) {
                    submission.updateComment(comment);
                  }
                }

                return _context.abrupt("return", Result.ok({
                  submission: submission
                }));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateSubmissionUseCase;
}(UseCase);